/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Kick_Members_HintInputs */



/**
* | output |
* | --- |
* | "Kick will remove other members from this server. Kicked members will be able to re-join if they have another invite. If the server enables Member Requirement..." |
*
* @param {Leveling_Perm_Kick_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_kick_members_hint = /** @type {((inputs?: Leveling_Perm_Kick_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Kick_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет выгонять других участников с сервера. Выгнанные участники смогут вернуться по новому приглашению. Если на сервере включены требования к участникам, это право позволяет ещё одобрять и отклонять заявки на вступление.")
	return /** @type {LocalizedString} */ ("Kick will remove other members from this server. Kicked members will be able to re-join if they have another invite. If the server enables Member Requirements, this permission enables the ability to approve or reject members who request to join.")
});